export default __webpack_public_path__ + "static/media/akachi-luccini@2x.2e10f9b4.jpg";